import { useTranslation } from "react-i18next";
import { fixtureNewsHeaderStyles } from "./fixtureNewsHeader.css";
import { NewsHeaderTeam } from "./NewsHeaderTeam";
import { FixtureNewsHeaderProps } from "./types";

const FixtureNewsHeader = ({ homeTeam, awayTeam }: FixtureNewsHeaderProps) => {
  const { t } = useTranslation();
  return (
    <h3 className={fixtureNewsHeaderStyles}>
      <NewsHeaderTeam team={homeTeam} />
      <span>{t("versusShort", "v")}</span>
      <NewsHeaderTeam team={awayTeam} isAwayTeam />
    </h3>
  );
};

export default FixtureNewsHeader;
